module.exports = __webpack_public_path__ + "img/img (50).22ed3c95.png";